import { render, staticRenderFns } from "./Comedies.vue?vue&type=template&id=24accf32&scoped=true&"
import script from "./Comedies.vue?vue&type=script&lang=js&"
export * from "./Comedies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24accf32",
  null
  
)

export default component.exports